module.exports = __webpack_public_path__ + "static/img/publicity-about.53fe285.webp";


//////////////////
// WEBPACK FOOTER
// ./static/publicity-about.webp
// module id = TJ2P
// module chunks = 1